// @ts-nocheck

"use client"

import NextNProgress from 'nextjs-progressbar'
import React from "react"

const ProgressBarPage = () => {
    return <NextNProgress color="#EBD29F" startPosition={0.3} stopDelayMs={200} height={3} showOnShallow={true} />
}

export default ProgressBarPage